import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setTabActive, setTabInactive } from '../store/entities/focused-tab-slice';

const useTabVisibility = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        dispatch(setTabInactive());
      } else {
        dispatch(setTabActive());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [dispatch]);
};

export default useTabVisibility;
